import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import livingRoom from "./components/living-room";
import conferenceRoom from "./components/conference-room";
import concertHall from "./components/concert-hall";

const principle: Slide = {
  description:
    "Observe exemplar acoustic parameters for various enclosed spaces. Analyze them in relation to the respective functional attributes of the objects.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Living room" }, { name: "Conference room" }, { name: "Concert hall" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], []],
      components: [livingRoom, conferenceRoom, concertHall],
    },
  },
};

export default principle;
